import classNames from "classnames";
import "./stepper.scss";

export type StepperProps = {
  steps: { label: string }[];
  currentStep: number;
};

const Stepper = ({ steps, currentStep }: StepperProps) => (
  <nav className="stepper" aria-label="Application progress">
    <ol className="stepper__list">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const reached = stepNumber <= currentStep;
        const current = stepNumber === currentStep;

        return (
          <li
            key={step.label}
            className={classNames("stepper__step", {
              "stepper__step--reached": reached,
              "stepper__step--current": current,
            })}
            aria-current={current ? "step" : undefined}
          >
            {index > 0 && (
              <span
                className={classNames("stepper__connector", {
                  "stepper__connector--reached": reached,
                })}
                aria-hidden="true"
              />
            )}
            <span className="stepper__marker" aria-hidden="true">
              {stepNumber}
            </span>
            <span className="stepper__label">{step.label}</span>
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Stepper;
